import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAppMode } from '@/hooks/use-app-mode';
import { MagicWandIcon } from '@radix-ui/react-icons';
import { MessageSquare } from 'lucide-react';

export function ModeSelector() {
  const { mode, setMode } = useAppMode();

  return (
    <Card className="mb-4 border-primary/20">
      <CardContent className="p-3">
        <Tabs defaultValue={mode} onValueChange={(value) => setMode(value as 'traditional' | 'ai')}>
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="traditional" className="flex items-center gap-2">
              <MessageSquare className="h-4 w-4" />
              <span>Traditional</span>
            </TabsTrigger>
            <TabsTrigger value="ai" className="flex items-center gap-2">
              <MagicWandIcon className="h-4 w-4" />
              <span>FlexHelp AI</span>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </CardContent>
    </Card>
  );
} 